var render = function render(){var _vm=this,_c=_vm._self._c;return _c('menu-layout',{attrs:{"loading":_vm.loading}},[_c('model-loader',{on:{"model_results_updated":_vm.model_results_updated}}),_c('confusion-matrix',{staticStyle:{"margin-top":"10px"},attrs:{"model_results":_vm.model_results}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }